/**
 * Comparator for sorting simple semantic version strings
 * based on code from https://github.com/substack/semver-compare
 * @param a string
 * @param b string
 * @returns number
 */
export const compareSemvers = (a: string, b: string) => {
  const pa = a.split('.');
  const pb = b.split('.');

  for (let i = 0; i < 3; i++) {
    const na = Number(pa[i]);
    const nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }
  return 0;
};
